import dayjs, { Dayjs } from 'dayjs';

import { RelativeDateOffset } from '@drivingdoc/shared-types/reports';

import { calculateDateFromOffset } from 'utils/reportParameters';

/**
 * Resolve the effective max date from a config's maxDateOffset and allowFutureDates flag.
 */
export function resolveMaxDate(
  maxDateOffset?: RelativeDateOffset,
  allowFutureDates?: boolean,
): Dayjs | undefined {
  let maxDate = maxDateOffset ? calculateDateFromOffset(maxDateOffset) : undefined;

  if (allowFutureDates === false) {
    const today = dayjs();
    maxDate = maxDate ? (maxDate.isBefore(today) ? maxDate : today) : today;
  }

  return maxDate;
}
